import React from 'react';
import * as api from '../../../../services/api';
import { Snackbar } from '@material-ui/core';
import CustomerRenewalTable from '../../../presenters/renewals/CustomerRenewalTable/CustomerRenewalTable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../RenewalsPortal/actions';
import { withRouter } from 'react-router-dom';
import { PRODUCT_LIST_URL } from '../../../../route-names';
import {
  getBranchIds,
  getBranchRouteNumbers
} from '../../../../utils/api-util';
import * as RenewalStatus from '../../../../constants/RenewalStatus';
import {
  DEFAULT_DIRECTION,
  DIRECTION,
  EMPTY_API_RESPONSE
} from '../../../../constants/constants';
import { injectIntl } from 'react-intl';
import { RENEWAL_COOL_OFF } from '../../../../constants/CustomerStatus';
import { DEFAULT_PAGEABLE } from '../../../../services/_api/shared';
import DialogSignatureRequired from '../../../presenters/renewals/ConfirmationDialogPresenter/dialogs/DialogSignatureRequired/DialogSignatureRequired';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import {
  APPROVE,
  APPROVE_AND_SEND_TO_CUSTOMER
} from '../../../../constants/WorkFlowAction';

const defaultTitle = (props) =>
  props.intl.formatMessage({
    id: 'renewals_action_panel_title'
  });

class CustomerRenewalTableWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: defaultTitle(props),
      page: DEFAULT_PAGEABLE.page,
      customers: [],
      message: null,
      sortBy: {
        name: 'contract.contractDateInactive',
        direction: DIRECTION.desc.name
      },
      popupCustomer: null,
      popupRenewal: null,
      loading: false
    };

    this.updateCurrentState = this.updateCurrentState.bind(this);
    this.filterOnURL = this.filterOnURL.bind(this);
    this.updateCustomers = this.updateCustomers.bind(this);
    this.extractAndSetState = this.extractAndSetState.bind(this);
    this.handleRequestSort = this.handleRequestSort.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleClickCustomer = this.handleClickCustomer.bind(this);
    this.determineStatus = this.determineStatus.bind(this);
    this.handleResendSignatureEmail =
      this.handleResendSignatureEmail.bind(this);
    this.onClose = this.onClose.bind(this);
    this.updateRenewal = this.updateRenewal.bind(this);
    this.submitRenewal = this.submitRenewal.bind(this);
  }

  componentDidMount() {
    this.updateCurrentState();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location.search !== prevProps.location.search ||
      this.props.appStore.activeBranchId !== prevProps.appStore.activeBranchId
    ) {
      this.updateCurrentState(true);
    }
  }

  updateCurrentState(doResetPage = false) {
    const url = new URL(window.location);

    let tblHeader = null;
    if (!!url.searchParams.get('title')) {
      tblHeader = this.props.intl.formatMessage({
        id: url.searchParams.get('title')
      });
    }

    this.setState(
      {
        title: tblHeader || defaultTitle(this.props),
        page: doResetPage ? DEFAULT_PAGEABLE.page : this.state.page,
        customers: []
      },
      () => {
        if (Array.from(url.searchParams.keys()).length === 0) {
          this.updateCustomers();
        } else {
          this.filterOnURL(url);
        }
      }
    );
  }

  filterOnURL(url) {
    const statusStr = url.searchParams.get('statuses');
    let statuses = null;
    if (statusStr) {
      statuses = statusStr.split(',');
    }

    const hasTriggerProducts = url.searchParams.get('hasTriggerProducts') === 'true';

    this.updateCustomers(
      url.searchParams.get('search'),
      url.searchParams.get('contractExpiresAfter'),
      url.searchParams.get('contractExpiresBefore'),
      statuses,
      url.searchParams.get('branchRouteNumber'),
      url.searchParams.get('day'),
      hasTriggerProducts
    );
  }

  updateCustomers(
    search,
    contractExpiresAfter,
    contractExpiresBefore,
    statuses,
    branchRouteNumber,
    dayId,
    hasTriggerProducts
  ) {
    const { activeBranchId, branches, routes } = this.props.appStore;

    const branchIds = getBranchIds(activeBranchId, branches);
    const branchRouteNumbers = getBranchRouteNumbers(
      branchRouteNumber,
      routes.filter((route) => branchIds.includes(route.branchId))
    );

    if (branchIds.length > 0 && branchRouteNumbers.length > 0) {
      this.setState(
        {
          loading: true
        },
        () => {
          const customerPromise = api.customers.search(
            {
              page: this.state.page,
              sortBy: this.state.sortBy
            },
            {
              search,
              contractExpiresAfter,
              contractExpiresBefore,
              statuses,
              branchIds,
              branchRouteNumbers,
              dayId,
              mustHaveContract: true,
              hasTriggerProducts
            }
          );

          const renewalPromise = customerPromise
            .then((customerResponse) => {
              if (customerResponse.data.content.length === 0) {
                return EMPTY_API_RESPONSE;
              }

              const customerIds = customerResponse.data.content
                .filter(
                  (customer) => customer.customerStatus !== RENEWAL_COOL_OFF
                )
                .map((customer) => customer.customerId);

              return customerIds.length > 0
                ? api.renewals.search(
                  {
                    page: {
                      size: this.state.page.size
                    }
                  },
                  {
                    customerIds,
                    statuses: [
                      RenewalStatus.IN_PROGRESS.name,
                      RenewalStatus.APPROVAL_REQUIRED.name,
                      RenewalStatus.CUSTOMER_APPROVAL_REQUIRED.name
                    ]
                  }
                )
                : {
                  data: {
                    content: []
                  }
                };
            })
            .catch(() => {
              Promise.reject();
            });

          Promise.all([customerPromise, renewalPromise])
            .then((responses) => {
              const [customerResponse, renewalResponse] = responses;
              this.extractAndSetState(renewalResponse, customerResponse);
            })
            .catch(() => {
              this.setState({
                loading: false,
                message: 'Unable to download renewal'
              });
            });
        }
      );
    }
  }

  extractAndSetState(renewalResponse, customerResponse) {
    const zipped = this.zipCustomersAndRenewals(
      renewalResponse.data.content,
      customerResponse.data.content
    );
    this.setState({
      customers: zipped,
      page: {
        size: customerResponse.data.size,
        totalElements: customerResponse.data.totalElements,
        number: customerResponse.data.number,
        numberOfElements: customerResponse.data.numberOfElements
      },
      loading: false
    });
  }

  zipCustomersAndRenewals(renewals, customers) {
    return customers
      .map((customer) => ({
        ...customer,
        renewal: renewals.find(
          (renewal) => renewal.customerId === customer.customerId
        )
      }))
      .map((customerWithRenewal) => ({
        ...customerWithRenewal,
        renewalStatus: this.determineStatus(customerWithRenewal)
      }));
  }

  determineStatus(customerWithRenewal) {
    if (customerWithRenewal.customerStatus === RENEWAL_COOL_OFF)
      return RenewalStatus.COMPLETED.name;
    return !!customerWithRenewal.workflowTicket
      ? customerWithRenewal.workflowTicket.status
      : RenewalStatus.NOT_STARTED.name;
  }

  handleRequestSort(name) {
    const direction =
      this.state.sortBy.name === name
        ? DIRECTION[this.state.sortBy.direction].opposite
        : DEFAULT_DIRECTION;

    this.setState(
      {
        sortBy: {
          name,
          direction
        }
      },
      this.updateCurrentState
    );
  }

  handleChangeRowsPerPage(rows) {
    this.setState(
      {
        page: {
          size: rows,
          numberOfElements: rows,
          totalElements: this.state.page.totalElements,
          number: 0
        }
      },
      this.updateCurrentState
    );
  }

  handleChangePage(number) {
    this.setState(
      {
        page: {
          ...this.state.page,
          number
        }
      },
      this.updateCurrentState
    );
  }

  handleClickCustomer(branchRouteCustomerId) {
    this.props.history.push(
      PRODUCT_LIST_URL.replace(':branchRouteCustomerId', branchRouteCustomerId)
    );
  }

  handleResendSignatureEmail(customer) {
    this.setState({
      popupCustomer: customer,
      popupRenewal: customer.renewal
    });
  }

  onClose() {
    this.setState({
      popupCustomer: null,
      popupRenewal: null
    });
  }

  updateRenewal(updatedRenewal, submitUpdates = true) {
    if (submitUpdates) {
      this.setState(
        {
          loading: true
        },
        () => {
          api.renewals
            .update(updatedRenewal)
            .then(() =>
              api.renewals.submit(
                updatedRenewal.renewalId,
                updatedRenewal.customerEmail
                  ? APPROVE_AND_SEND_TO_CUSTOMER
                  : APPROVE
              )
            )
            .then(() =>
              this.setState(
                {
                  message: this.props.intl.formatMessage({
                    id: 'renewal_updated'
                  }),
                  popupCustomer: null,
                  popupRenewal: null
                },
                () => {
                  this.updateCurrentState();
                }
              )
            )
            .catch((error) => {
              console.error(error);
              this.setState({
                loading: false,
                message: this.props.intl.formatMessage({
                  id: 'error_updating_renewal'
                })
              });
            });
        }
      );
    } else {
      this.setState({
        popupRenewal: updatedRenewal
      });
    }
  }

  submitRenewal() {
    this.updateRenewal(this.state.popupRenewal, true);
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <div>
        <CustomerRenewalTable
          customers={this.state.customers}
          title={this.state.title}
          page={this.state.page}
          sortBy={this.state.sortBy}
          handleRequestSort={this.handleRequestSort}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleClickCustomer={this.handleClickCustomer}
          handleResendSignatureEmail={this.handleResendSignatureEmail}
        />
        {this.state.popupCustomer && this.state.popupRenewal ? (
          <DialogSignatureRequired
            open={true}
            onClose={this.onClose}
            onAccept={this.submitRenewal}
            data={{
              customer: this.state.popupCustomer,
              renewal: this.state.popupRenewal,
              updateRenewal: this.updateRenewal
            }}
          />
        ) : null}
        <Snackbar
          open={!!this.state.message}
          onClose={() => {
            this.setState({ message: null });
          }}
          autoHideDuration={5000}
          message={this.state.message}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CustomerRenewalTableWrapper)
  )
);